import React, { useState, useEffect, useMemo } from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { getEntitiesWithAddress } from '../../../../utils/getEntitiesWithAddress';
import TenantsBlock from '../../../../components/ui/TenantsBlock/TenantsBlock';
import useFlatsGridState from '../../../../hooks/useFlatsGridState';
import useHousingStockState from '../../../../hooks/useHousingStockState';

const HouseTenants = () => {
  const [tenants, setTenants] = useState([]);

  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const { flatsGridQueryKey, flatsGridState } = useFlatsGridState();
  const { housingStockQueryKey } = useHousingStockState();

  const flats = useMemo(() => flatsGridState?.data || [], [flatsGridState]);

  useEffect(() => {
    if (flats.length) {
      const tenants = getEntitiesWithAddress(flats, 'clients');
      setTenants(tenants);
    }
  }, [flats]);

  return (
    <div>
      <Spin spinning={flatsGridState?.isFetching}>
        <TenantsBlock
          tenants={tenants}
          companyName={currentCompany?.name}
          queryKeys={[flatsGridQueryKey, housingStockQueryKey]}
        />
      </Spin>
    </div>
  );
};

export default HouseTenants;
